function formatString(input, delimiter = '_') {
  if (typeof input !== 'string') {
    throw new TypeError('Input must be a string');
  }

  return input
    .split(delimiter)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export default formatString;

export const formatName = (input) => {
  if (typeof input !== 'string') {
    return '';
  }

  const [firstName, lastName] = input.split(' ');

  return `${firstName?.charAt(0)?.toUpperCase()}${lastName?.charAt(0)?.toUpperCase()}` || '';
};
